<template>
    <V1 v-if="isOld"></V1>
    <!-- 云广播 -->
    <div v-else class="person_box animate__animated animate__fadeIn">
        <div class="person">
            <div class="search_box">
                <div class="box_line">
                    <div class="line_input">
                        <div class="input_title">任务名称</div>
                        <input type="text" class="input_box" placeholder="请输入任务名称" v-model="searchName" />
                    </div>

                    <div class="search-btn" @click="fnSearch"><span>搜索</span></div>
                    <div class="search-btn btn_green" style="width: 120px;" @click="libraryVisible = true">
                        <span>媒体库</span>
                    </div>

                    <div v-if="plan_selected" style="margin-left: 30px;">
                        <el-button type="primary" icon="el-icon-video-play" size="mini" v-if="!plan_selected.activated"
                            @click="fnPlanControl('start')">执行方案</el-button>
                        <el-button type="danger" icon="el-icon-video-pause" size="mini" v-else
                            @click="fnPlanControl('stop')">停止方案</el-button>
                        <el-button type="success" icon="el-icon-edit" size="mini"
                            @click="fnOpenEditPlanWin(false)">编辑方案</el-button>
                        <el-button type="info" icon="el-icon-copy-document" size="mini"
                            @click="fnOpenEditPlanWin(true)">复制方案</el-button>
                        <el-button type="danger" icon="el-icon-delete" size="mini"
                            @click="fnPlanDelete">删除方案</el-button>
                    </div>

                    <el-button type="warning" round icon="el-icon-plus" size="mini" style="margin-left: 30px;"
                        @click="fnOpenAddPlanWin">添加方案</el-button>
                    <el-button type="warning" round icon="el-icon-plus" size="mini"
                        @click="fnOpenAddTaskWin">添加任务</el-button>

                </div>
            </div>

            <div style="display: flex;width: 1864px;">
                <div class="cont_list">
                    <div class="list_title" style="width: 100%;">
                        <div class="title_item">方案</div>
                    </div>
                    <div class="list_boxes" style="width: 100%;">
                        <div class="list_box">
                            <div v-if="plan">
                                <div class="box_line" style="width: 80%;" v-for="(item, index) in plan" :key="index"
                                    @click="fnPlanSelect(index)">
                                    <div class="list_item" :class="item.id == plan_selected.id ? 'selected' : ''"
                                        style="margin-right: 0;cursor: pointer;" :title="item.name">
                                        <span
                                            style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ item.name }}
                                        </span>
                                        <span v-if="item.activated"
                                            style="color: #67c23a;font-size: 12px;margin-left: 5px;">执行中</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="cont_list" style="width: 82%;">
                    <div class="list_title" style="width: 100%;">
                        <div class="title_item">任务名称</div>
                        <div class="title_item">优先级</div>
                        <div class="title_item">音源</div>
                        <div class="title_item">生效状态</div>
                        <div class="title_item">播放状态</div>
                        <div class="title_item">循环状态</div>
                        <div class="title_item">播放时段</div>
                        <div class="title_item">操作</div>
                    </div>
                    <div class="list_boxes" style="width: 100%;">
                        <div class="list_box">
                            <div v-if="task">
                                <div class="box_line" style="width: 97%;" v-for="(item, index) in task" :key="index">
                                    <div class="list_item">{{ item.name }}</div>
                                    <div class="list_item">{{ item.priority }}</div>
                                    <div class="list_item">{{ fnGetAudioName(item.file_ids) }}</div>
                                    <div class="list_item">
                                        <span v-if="item.in_effect == 0">未生效</span>
                                        <span v-else style="color: #67c23a;">生效中</span>
                                    </div>
                                    <div class="list_item">
                                        <span v-if="item.play_status == 0">空闲</span>
                                        <span v-else-if="item.play_status == 1">暂停</span>
                                        <span v-else-if="item.play_status == 2">播放中</span>
                                        <span v-else-if="item.play_status == 3">人工停止</span>
                                        <span v-else-if="item.play_status == 4">人工播放中</span>
                                    </div>
                                    <div class="list_item">{{ item.loop==0 ? '播放一次' : '循环播放' }}</div>
                                    <div class="list_item">
                                        {{ fnFormatTiem(item.start_time)+'-'+ fnFormatTiem(item.end_time) }}
                                    </div>

                                    <div class="list_item">
                                        <div>
                                            <el-button type="primary" size="mini" title="播放"
                                                @click="fnTaskControl(item.id,'start')"
                                                v-if="item.play_status == 0 || item.play_status == 1 || item.play_status == 3 "
                                                icon="el-icon-video-play" circle></el-button>
                                            <el-button type="warning" size="mini" title="暂停"
                                                @click="fnTaskControl(item.id,'pause')"
                                                v-if="item.play_status == 2 || item.play_status == 4"
                                                icon="el-icon-video-pause" circle></el-button>
                                            <el-button type="danger" size="mini" title="停止"
                                                @click="fnTaskControl(item.id,'stop')"
                                                v-if="item.play_status != 0 && item.play_status != 3"
                                                icon="el-icon-close" circle></el-button>
                                            <el-button type="success" size="mini" title="编辑" icon="el-icon-edit" circle
                                                @click="fnOpenEditTaskWin(item)"></el-button>
                                            <el-button type="info" size="mini" title="复制" icon="el-icon-copy-document"
                                                circle @click="fnOpenEditTaskWin(item,true)"></el-button>
                                            <el-button type="danger" size="mini" title="删除" icon="el-icon-delete" circle
                                                @click="fnTaskDelete(item.id)"></el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 新增、编辑弹窗 -->
            <div class="dialog_editdevice animate__animated animate__fadeIn" v-if="saveTaskVisible">
                <el-dialog :title="saveTaskTitle" :modal="false" :visible.sync="saveTaskVisible" center
                    style="text-align: center">
                    <div class="search_box" style="width:100%;height:420px;margin:auto;">

                        <div class="box_line line_input_dialog">
                            <div class="line_input plan">
                                <div class="input_title must">所属方案</div>
                                <el-select size="small" v-model="form_task.plan_id" filterable
                                    :popper-append-to-body="false" style="width:480px;">
                                    <el-option v-for="item in plan" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title must">任务名称</div>
                                <input type="text" class="input_box" placeholder="请输入任务名称" v-model="form_task.name" />
                                <div class="input_title must">优先级</div>
                                <el-input-number v-model="form_task.priority" :min="0" :max="100"></el-input-number>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title must">播放设备</div>
                                <el-select size="small" v-model="form_task.device_ids" filterable
                                    :popper-append-to-body="false" style="width:480px;" multiple collapse-tags>
                                    <el-option v-for="item in devices"
                                        :label="item.name+(item.online ? '(在线)' : '(离线)')" :value="item.id"></el-option>
                                </el-select>
                                <div class="input_title">音量</div>
                                <el-input-number v-model="form_task.volume" :min="0" :max="100"></el-input-number>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input" style="background-color: unset;">
                                <div style="background-color: rgba(49, 88, 128, 0.4);">
                                    <div class="input_title must">音频</div>
                                </div>
                                <el-select size="small" v-model="form_task.file_ids" filterable
                                    :popper-append-to-body="false"
                                    style="width:390px;background-color: rgba(49,88,128,.4);margin-right: 8px;" multiple
                                    collapse-tags>
                                    <el-option v-for="item in library" v-if="item.audio_file_id" :label="item.name"
                                        :value="item.audio_file_id"></el-option>
                                </el-select>
                                <div class="search-btn" @click="fnOpenAddWin"><span>新增音频</span></div>
                            </div>
                        </div>


                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">播放顺序</div>
                                <el-radio-group v-model="form_task.play_order" style="margin-left: 10px;">
                                    <el-radio :label="0">顺序播放</el-radio>
                                    <el-radio :label="1">随机播放</el-radio>
                                </el-radio-group>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">循环类型</div>
                                <el-radio-group v-model="form_task.loop" style="margin-left: 10px;">
                                    <el-radio :label="0">播放一次</el-radio>
                                    <el-radio :label="1">循环播放</el-radio>
                                </el-radio-group>
                                <div class="input_title" style="margin-left: 71px;">播放间隔(秒)</div>
                                <el-input-number v-model="form_task.interval_time" :min="0"></el-input-number>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">播放频次</div>
                                <el-radio-group v-model="form_task.weekday_flags" style="margin-left: 10px;">
                                    <el-radio :label="0">每天</el-radio>
                                    <el-radio :label="1">工作日</el-radio>
                                    <el-radio :label="2">手动选择</el-radio>
                                    <el-radio :label="3">手动播放</el-radio>
                                </el-radio-group>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog" v-if="form_task.weekday_flags == 2">
                            <div class="line_input">
                                <div class="input_title">频次选择</div>
                                <el-select size="small" v-model="form_task.selected_weekday" filterable
                                    :popper-append-to-body="false" style="width:480px;" multiple>
                                    <el-option v-for="item in [
                                        {id:1,name:'星期一'},
                                        {id:2,name:'星期二'},
                                        {id:3,name:'星期三'},
                                        {id:4,name:'星期四'},
                                        {id:5,name:'星期五'},
                                        {id:6,name:'星期六'},
                                        {id:0,name:'星期日'}
                                    ]" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">有效期</div>
                                <el-date-picker v-model="form_task.date" type="daterange" align="left" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                    value-format="yyyyMMdd" class="el-range-editor-my">
                                </el-date-picker>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title must">播放时段</div>
                                <el-time-picker is-range v-model="form_task.time" range-separator="至"
                                    start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"
                                    class="el-range-editor-my">
                                </el-time-picker>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">脱机任务</div>
                                <el-radio-group v-model="form_task.offline" style="margin-left: 10px;">
                                    <el-radio :label="0">关闭</el-radio>
                                    <el-radio :label="1">开启</el-radio>
                                </el-radio-group>
                            </div>
                        </div>

                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="saveTaskVisible = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnSaveTask"><span>保存</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>

            <div class="dialog_library animate__animated animate__fadeIn" v-if="libraryVisible">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="媒体库" top="20vh"
                    center :visible.sync="libraryVisible">
                    <div class="cont_list" style="width: 720px;height: 380px;color: #fff;">
                        <div class="list_title" style="width: 720px;">
                            <div class="title_item" style="width: 180px;">音频名称</div>
                            <div class="title_item" style="width: 150px;">音频时长</div>
                            <div class="title_item" style="width: 150px;">音频类型</div>
                            <div class="title_item" style="width: 170px;">操作</div>
                        </div>
                        <div class="list_boxes" style="width: 720px;height: 330px;">
                            <div class="list_box" style="width: 720px;height: 330px;">
                                <div class="box_line" v-for="(item, index) in library" :key="index">
                                    <div class="list_item" style="width: 180px;">{{ item.name }}</div>
                                    <div class="list_item" style="width: 150px;">{{ item.audio_duration }}秒</div>
                                    <div class="list_item" style="width: 150px;">
                                        <span v-if="item.type == 0">文本转语音</span>
                                        <span v-else-if="item.type == 1">音频文件</span>
                                        <span v-else-if="item.type == 2">录音</span>
                                    </div>
                                    <div class="list_item" style="width: 170px;">
                                        <div>
                                            <div class="search-btn" @click="fnOpenEditWin(item)"><span>编辑</span></div>
                                            <div class="search-btn red" @click="fnDeleteAudio(item)"><span>删除</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer" align="center">
                        <div class="btn_line">
                            <div class="search-btn red" @click="libraryVisible = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnOpenAddWin"><span>新增音频</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>

            <div class="dialog_editfile" v-if="saveVisible">
                <el-dialog :title="saveTitle" :modal="false" :visible.sync="saveVisible" center
                    style="text-align: center">
                    <div class="search_box" style="width:100%;height:300px;margin:auto;">

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">音频名称</div>
                                <input type="text" class="input_box" placeholder="请输入广播名称" v-model="form.name" />
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">音频类型</div>
                                <el-radio-group v-model="form.type" style="margin-left: 10px;">L
                                    <el-radio :label="0">文本转语音</el-radio>
                                    <el-radio :label="1">音频文件</el-radio>
                                </el-radio-group>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog" style="height: 117px;">
                            <div class="line_input" style="height: 117px;">
                                <div class="input_title" style="height: 117px;">音频文本</div>
                                <el-input :disabled="form.type != 0" type="textarea" :rows="5"
                                    placeholder="请输入文字转语音文本,最多300字!" v-model="form.audio_text" resize="none"
                                    @input="fnChangeAudioText" />
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">文字转语音性别</div>
                                <el-radio-group v-model="form.audio_text_sex" :disabled="form.type != 0"
                                    style="margin-left: 10px;">
                                    <el-radio :label="1">男</el-radio>
                                    <el-radio :label="0">女</el-radio>
                                </el-radio-group>
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">音频文件</div>
                                <span class="fileinput-button">
                                    <span v-if="!audio_file">{{form.type == 0 ? "文本转语音无需选择" : "选择音频文件"}}</span>
                                    <span v-else>{{form.type == 0 ? "已上传" : (form.id ? "重新上传" :  "重新选择")}}</span>
                                    <input v-if="form.type != 0" type="file" name="audio_file" accept="audio/mp3"
                                        @change="changeFile">
                                </span>
                                <audio v-if="audio_file" controls="controls" style="width: 2200px; height: 30px;"
                                    :src="audio_file"></audio>
                            </div>
                        </div>

                    </div>
                    <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                        <div class="btn_line">
                            <div class="search-btn red" @click="saveVisible = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnSave"><span>保存</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>

            <div class="dialog_editfile" v-if="savePlanVisible" style="height: ;">
                <el-dialog :title="savePlanTitle" :modal="false" :visible.sync="savePlanVisible" center
                    style="text-align: center;">
                    <div class="search_box" style="width:100%;height:80px;margin:auto;">

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">方案名称</div>
                                <input type="text" class="input_box" placeholder="请输入方案名称" v-model="form_plan.name" />
                            </div>
                        </div>

                        <div class="box_line line_input_dialog">
                            <div class="line_input">
                                <div class="input_title">有效期</div>
                                <el-date-picker v-model="form_plan.date" :disabled="form_plan.is_copy" type="daterange"
                                    align="left" unlink-panels range-separator="至" start-placeholder="开始日期"
                                    end-placeholder="结束日期" value-format="yyyyMMdd" class="el-range-editor-my">
                                </el-date-picker>
                            </div>
                        </div>

                    </div>
                    <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                        <div class="btn_line">
                            <div class="search-btn red" @click="savePlanVisible = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnSavePlan"><span>保存</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>

        </div>
    </div>
</template>

<script>
    import V1 from './index'
    import request from '@/utils/request';
    import APP from '@/utils/base';
    import {
        getUserInfo
    } from '@/utils/auth';

    export default {
        components: {
            V1
        },
        data() {
            return {
                isOld: false,
                saveTitle: '新增音频',
                saveVisible: false,
                savePlanTitle: '新增方案',
                savePlanVisible: false,
                saveTaskTitle: '新增任务',
                saveTaskVisible: false,
                searchName: '',
                form: {
                    id: '', // 云广播id
                    name: '', // 广播名称
                    type: 0, // 语音类型
                    audio_text: '', // 音频文本
                    audio_text_sex: 1, // 文字转语音性别
                    audio_file: '', // 音频文件
                    status: 1, // 状态
                },
                form_task: {
                    id: null, // 任务id
                    name: '', // 任务名称
                    priority: 70, // 优先级
                    volume: 100, // 音量
                    device_ids: [], // 播放设备
                    file_ids: [], // 音频
                    play_order: 0, // 播放顺序
                    loop: 0, // 循环类型
                    weekday_flags: 3, // 播放频次
                    selected_weekday: [1, 2, 3, 4, 5, 6], // 频次选择
                    date: ['20230101', '20991231'], // 有效期
                    time: [new Date('2023-01-01 09:00:00'), new Date('2023-01-01 18:00:00')], // 播放时段
                    interval_time: 0, // 播放间隔(秒)
                    offline: 0, // 脱机任务
                    plan_id: null,
                },
                form_plan: {
                    id: null, // 方案id
                    name: '', // 方案名称
                    date: ['20230101', '20991231'], // 有效期
                    is_copy: false
                },
                audio_file: '',

                library: [],
                libraryVisible: false,
                selectLibrary: [], // 选中的音频
                selectAllLibrary: false,

                task: [],
                task_id: null,
                plan: [],
                plan_selected: null,

                devices: [],
            };
        },
        created() {
            this.fnGetData();
        },
        methods: {
            fnPlanDelete() {

                if (this.plan.length == 1) {
                    this.$message.error("最后一个方案不能删除！");
                    return
                }

                this.$confirm('确认需要删除此方案, 是否继续?', '提示', {
                        confirmButtonText: '删除',
                        cancelButtonText: '取消',
                        center: true
                    })
                    .then(() => {
                        request({
                                url: '/audiov2/request',
                                method: 'POST',
                                data: {
                                    method: 'DELETE',
                                    url: '/v1/plan/' + this.plan_selected.id,
                                    upload_data: null
                                }
                            })
                            .then(res => {
                                this.$message.success('删除成功！');
                                this.fnGetData()
                            })
                            .catch(err => {
                                this.$message.error(err.data);
                            });
                    })
                    .catch(() => {});
            },
            fnSavePlan() {
                let _obj = {
                    name: this.form_plan.name,
                    start_date: parseInt(this.form_plan.date[0]),
                    end_date: parseInt(this.form_plan.date[1]),
                }

                if (!_obj.name) {
                    this.$message.error('方案名称不能为空！');
                    return
                }

                let data = {}
                if (this.form_plan.is_copy) {
                    data = {
                        method: 'POST',
                        url: '/v1/plan/copy?t=new',
                        upload_data: {
                            new_plan_name: this.form_plan.name,
                            src_plan_id: this.form_plan.id
                        }
                    }
                } else {
                    data = {
                        method: this.form_plan.id ? 'PATCH' : 'POST',
                        url: '/v1/plan' + (this.form_plan.id ? '/' + this.form_plan.id : '') + '?t=new',
                        upload_data: _obj
                    }
                }

                request({
                        url: '/audiov2/request',
                        method: 'POST',
                        data: data
                    })
                    .then(res => {
                        this.savePlanVisible = false
                        this.$message.success(this.savePlanTitle + '成功');
                        this.fnGetData()
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            fnPlanControl(_type) {
                request({
                        url: '/audiov2/request',
                        method: 'POST',
                        data: {
                            method: 'GET',
                            url: '/v1/plan/' + this.plan_selected.id + '/' + _type,
                            upload_data: null
                        }
                    })
                    .then(res => {
                        this.fnGetData(this.plan_selected.id)
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            fnTaskDelete(_id) {
                this.$confirm('确认需要删除此任务, 是否继续?', '提示', {
                        confirmButtonText: '删除',
                        cancelButtonText: '取消',
                        center: true
                    })
                    .then(() => {
                        request({
                                url: '/audiov2/request',
                                method: 'POST',
                                data: {
                                    method: 'DELETE',
                                    url: '/v1/task/' + _id,
                                    upload_data: null
                                }
                            })
                            .then(res => {
                                this.$message.success('删除成功！');
                                this.fnGetTask()
                            })
                            .catch(err => {
                                this.$message.error(err.data);
                            });
                    })
                    .catch(() => {});
            },
            fnSaveTask() {

                let _obj = JSON.parse(JSON.stringify(this.form_task))

                if (!_obj.name) {
                    this.$message.error('任务名称不能为空！');
                    return
                }

                if (!_obj.device_ids.length) {
                    this.$message.error('请选择播放设备！');
                    return
                }

                if (!_obj.file_ids.length) {
                    this.$message.error('请选择播放音频！');
                    return
                }

                delete _obj.id
                delete _obj.date
                delete _obj.time

                _obj.duration_type = 0
                _obj.duration = parseInt(this.form_task.time[1] - this.form_task.time[0])
                _obj.start_time = parseInt(this.form_task.time[0].Format('hhmmss'))
                _obj.end_time = parseInt(this.form_task.time[1].Format('hhmmss'))

                _obj.start_date = parseInt(this.form_task.date[0])
                _obj.end_date = parseInt(this.form_task.date[1])

                request({
                        url: '/audiov2/request',
                        method: 'POST',
                        data: {
                            method: this.form_task.id ? 'PATCH' : 'POST',
                            url: '/v1/task' + (this.form_task.id ? '/' + this.form_task.id : '') + '?t=new',
                            upload_data: _obj
                        }
                    })
                    .then(res => {
                        this.saveTaskVisible = false
                        this.$message.success(this.saveTaskTitle + '成功');
                        this.fnGetTask()
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            fnTaskControl(_id, _type) {
                request({
                        url: '/audiov2/request',
                        method: 'POST',
                        data: {
                            method: 'GET',
                            url: '/v1/task/' + _id + '/' + _type,
                            upload_data: null
                        }
                    })
                    .then(res => {
                        this.saveTaskVisible = false
                        this.fnGetTask()
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            fnFormatTiem(_time) {
                _time += ""
                if (_time < 100000) {
                    _time = _time.padStart(6, '0');
                }

                return _time.slice(0, 2) + ':' + _time.slice(2, 4) + ':' + _time.slice(4);
            },
            fnGetAudioName(_ids) {
                let name = ''
                for (let i in _ids) {
                    for (let index in this.library) {
                        if (this.library[index].audio_file_id == _ids[i]) {
                            name += this.library[index].name + '、'
                        }
                    }
                }

                return name.substr(0, name.length - 1);
            },
            fnChangeAudioText() {
                this.audio_file = ''
            },
            // 更改分页内容
            handleSizeChange(val) {
                this.pageSize = val;
                this.fnSearch(false);
            },
            // 翻页
            handleCurrentChange(val) {
                this.currentPage = val;
                this.fnSearch(false);
            },
            changeFile(e) {
                this.form.audio_file = e.target.files[0]
                this.audio_file = URL.createObjectURL(this.form.audio_file)
            },
            //获取设备数据
            fnGetData(_plan_id) {

                // 获取媒体库
                request({
                        url: '/audiov2/getAllAudio',
                        method: 'GET'
                    })
                    .then(res => {
                        if (res.data == 'old') {
                            this.isOld = true
                            return
                        }

                        let library = res.data
                        for (let i in library) {
                            library[i].selected = false
                        }

                        this.library = library


                        // 获取设备数据
                        request({
                                url: '/audiov2/request',
                                method: 'POST',
                                data: {
                                    method: 'GET',
                                    url: '/v1/group',
                                    upload_data: null
                                }
                            })
                            .then(res => {
                                this.devices = res.data[0].devices
                            })
                            .catch(err => {
                                this.$message.error(err.data);
                            });

                        // 获取方案
                        request({
                                url: '/audiov2/request',
                                method: 'POST',
                                data: {
                                    method: 'GET',
                                    url: '/v1/plan',
                                    upload_data: null
                                }
                            })
                            .then(res => {
                                this.plan = res.data

                                if (_plan_id) {
                                    for (let i in this.plan) {
                                        if (this.plan[i].id == _plan_id) {
                                            this.plan_selected = this.plan[i]
                                            break
                                        }
                                    }
                                } else {
                                    this.plan_selected = this.plan[0]
                                }

                                this.fnGetTask()
                            })
                            .catch(err => {
                                this.$message.error(err.data);
                            });
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            fnPlanSelect(_i) {
                this.plan_selected = this.plan[_i]
                this.fnGetTask()
            },
            // 获取任务
            fnGetTask() {
                request({
                        url: '/audiov2/request',
                        method: 'POST',
                        data: {
                            method: 'GET',
                            url: '/v1/task?plan_id=' + this.plan_selected.id + '&name=' + this.searchName,
                            upload_data: null
                        }
                    })
                    .then(res => {
                        this.task = res.data
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 搜索
            fnSearch(_isReset = true) {
                this.fnGetData();
            },

            fnOpenAddPlanWin() {
                this.savePlanTitle = '新增方案'
                this.form_plan.id = null; // 任务id
                this.form_plan.is_copy = false;
                this.form_plan.name = ''; // 任务名称
                this.form_plan.date = ['20230101', '20991231']; // 有效期
                this.savePlanVisible = true;
            },
            fnOpenEditPlanWin(_is_copy) {
                this.savePlanTitle = _is_copy ? '复制方案' : '编辑方案';
                this.form_plan.id = this.plan_selected.id; // 任务id
                this.form_plan.is_copy = _is_copy; // 任务id
                this.form_plan.name = this.plan_selected.name; // 任务名称
                this.form_plan.date = [this.plan_selected.start_date + "", this.plan_selected.end_date + ""]; // 有效期
                this.savePlanVisible = true;
            },

            fnOpenAddTaskWin() {
                this.saveTaskTitle = '新增任务'
                this.form_task.id = null; // 任务id
                this.form_task.name = ''; // 任务名称
                this.form_task.priority = 70; // 优先级
                this.form_task.volume = 100; // 音量
                this.form_task.device_ids = []; // 播放设备
                this.form_task.file_ids = []; // 音频
                this.form_task.play_order = 0; // 播放顺序
                this.form_task.loop = 0; // 循环类型
                this.form_task.weekday_flags = 3; // 播放频次
                this.form_task.selected_weekday = [1, 2, 3, 4, 5, 6]; // 频次选择
                this.form_task.date = ['20230101', '20991231']; // 有效期
                this.form_task.time = [new Date('2023-01-01 09:00:00'), new Date('2023-01-01 18:00:00')]; // 播放时段
                this.form_task.interval_time = 0; // 播放间隔(秒)
                this.form_task.offline = 0; // 脱机任务
                this.form_task.plan_id = this.plan_selected.id
                this.saveTaskVisible = true;
            },
            // 打开编辑设备窗口
            fnOpenEditTaskWin(_data, _is_copy) {
                this.saveTaskTitle = _is_copy ? '复制任务' : '编辑任务';
                this.form_task.id = _is_copy ? null : _data.id; // 任务id
                this.form_task.name = _data.name; // 任务名称
                this.form_task.priority = _data.priority; // 优先级
                this.form_task.volume = _data.volume; // 音量
                this.form_task.device_ids = _data.device_ids; // 播放设备
                this.form_task.file_ids = _data.file_ids; // 音频
                this.form_task.play_order = _data.play_order; // 播放顺序
                this.form_task.loop = _data.loop; // 循环类型
                this.form_task.weekday_flags = _data.weekday_flags; // 播放频次
                this.form_task.selected_weekday = _data.selected_weekday; // 频次选择
                this.form_task.date = [_data.start_date + "", _data.end_date + ""]; // 有效期
                this.form_task.time = [new Date('2023-01-01 ' + this.fnFormatTiem(_data.start_time)), new Date(
                    '2023-01-01 ' + this.fnFormatTiem(_data.end_time))]; // 播放时段
                this.form_task.interval_time = _data.interval_time; // 播放间隔(秒)
                this.form_task.offline = _data.offline; // 脱机任务
                this.form_task.plan_id = _data.plan_id
                this.saveTaskVisible = true;
            },
            // 打开新增设备窗口
            fnOpenAddWin() {
                this.saveTitle = '新增音频'
                this.form.id = '';
                this.form.name = '';
                this.form.type = 0;
                this.form.audio_text = '';
                this.form.audio_text_sex = 1;
                this.form.audio_file = '';
                this.audio_file = '';
                this.form.status = 1;
                this.saveVisible = true;
                this.saveTaskVisible = false
            },
            // 打开编辑设备窗口
            fnOpenEditWin(_data) {
                this.saveTitle = '编辑音频'
                this.form.id = _data.id;
                this.form.name = _data.name;
                this.form.type = _data.type;
                this.form.audio_text = _data.audio_text;
                this.form.audio_text_sex = _data.audio_text_sex;
                this.form.audio_file = _data.audio_file;
                this.audio_file = _data.audio_file;
                this.form.status = _data.status;
                this.saveVisible = true;
            },
            // 编辑设备
            fnSave() {

                if (!this.devices.length) {
                    this.$message.error('该项目无播放设备，无法添加音频！');
                    return
                }

                if (!this.form.name) {
                    this.$message.error('音频名称必填！');
                    return
                }

                if (this.form.type == 0 && !this.form.audio_text) {
                    this.$message.error('音频文本必填！');
                    return
                }
                
                if (this.form.type == 1 && !this.form.audio_file) {
                    this.$message.error('音频文件必选！');
                    return
                }

                let formData = new FormData();
                for (let i in this.form) {
                    formData.append(i, this.form[i]);
                }

                request({
                        url: '/audiov2/saveAudio',
                        method: 'POST',
                        data: formData
                    })
                    .then(res => {
                        this.$message.success(res.data);
                        this.saveVisible = false;
                        this.fnSearch();
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            fnDeleteAudio(_data) {
                this.$confirm('确认删除该音频？')
                    .then(_ => {
                        request({
                                url: '/audiov2/deleteAudio',
                                method: 'POST',
                                data: {
                                    id: _data.id
                                }
                            })
                            .then(res => {
                                this.$message.success(res.data);
                                this.fnSearch();
                            })
                            .catch(err => {
                                this.$message.error(err.data);
                            });
                    });
            },
        }
    };
</script>

<style scoped lang="scss" type="text/scss">
    @import '~@/styles/mixin.scss';
.person_box {
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.person {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.search_box {
	width: 1880px;
	margin-top: 24px;
	margin-left: 20px;
	@include flex-box(space-between, center, column);
	.box_line {
		width: 1880px;
		height: 32px;
		@include flex-box(flex-start, center);
		.line_input {
			min-width: 280px;
			height: 30px;
			margin-right: 10px;
			border-top-right-radius: 1px;
			border-bottom-right-radius: 1px;
			background-color: rgba(49, 88, 128, 0.4);
			@include flex-box(flex-start, center);
			.input_title {
				padding: 0 5px;
				min-width: 69px;
				height: 30px;
				font-size: 14px;
				color: #9bf9fc;
				border-radius: 2px;
				background-color: rgba(155, 249, 252, 0.1);
				@include flex-box(center, center);
			}
            .must{
                color: #F56C6C;
            }
			.input_box {
				width: 211px;
				height: 30px;
				line-height: 30px;
				padding-left: 15px;
				color: rgba(77, 180, 244, 0.7);
				font-size: 12px;
				border-radius: 2px;
				outline: none;
				background: transparent;
				border: none;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
			.select_box {
				width: 211px;
				height: 30px;
				border-radius: 2px;
			}
		}
    }
    .line_input_dialog{

        .line_input{
            margin:auto;
            width: 550px;
            .input_box{
                width: 480px;
            }
             >>> .el-radio {
               color: rgba(255, 255, 255, 0.8);
             }

            .fileinput-button {
                width: 400px;
                margin-left: 10px;
                color: rgba(255, 255, 255, 0.8);
                position: relative;
                display: inline-block;
                overflow: hidden;
                cursor: pointer;
            }
            .fileinput-button input{
                position: absolute;
                left: 0px;
                top: 0px;
                opacity: 0;
                -ms-filter: 'alpha(opacity=0)';
                cursor: pointer;
            }
            .timed-select{
                width: 85px;
                background-color: rgba(255,255,255,.8);
                margin-right: 3px;
                border-radius: 5px;
            }

            >>> .el-input__icon,>>> .el-range-separator{
                line-height: 25px;
                color: #409eff;
            }
        }

        .plan{
            >>> .el-input--suffix{
                input{
                    width: 480px;
                }
            }
        }

    }
}
.cont_list {
	margin-top: 29px;
	margin-left: 28px;
	width: 932px;
	height: 750px;
	border-radius: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.list_title {
		width: 932px;
		height: 48px;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);
		.title_item {
			height: 48px;
			@include flex-box(center, center);
			&:nth-child(1) {
                width: 292px;
                margin: 0 4px 0 20px;
			}
			&:nth-child(2) {
				width: 96px;
                margin-right: 4px;
			}
			&:nth-child(3) {
				width: 255px;
				margin-right: 4px;
			}
			&:nth-child(4) {
				width: 116px;
				margin-right: 4px;
			}
			&:nth-child(5) {
				width: 116px;
				margin-right: 4px;
			}
			&:nth-child(6) {
				width: 116px;
                margin-right: 4px;
			}
			&:nth-child(7) {
				width: 190px;
				margin-right: 4px;
			}
			&:nth-child(8) {
				width: 242px;
			}

            .select {
              width: 20px;
              height: 20px;
              border: 1px solid #65a6dd;
              border-radius: 2px;
              cursor: pointer;
              @include prefixCss3(transition, border-color 0.2s);
              &:hover {
                border-color: #409eff;
              }
              &.active {
                background-color: #409eff;
                border-color: #409eff;
                &::after {
                  content: '';
                  display: block;
                  width: 100%;
                  height: 100%;
                  @include set-bg-img('../../../assets/images/icon-yes.png');
                }
              }
            }
		}
	}
	.list_boxes {
		width: 932px;
		height: 690px;
		position: relative;
		overflow: hidden;
		.list_box {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.box_line {
				width: 932px;
				min-height: 70px;
				margin: 7px 0 0 20px;
				font-size: 16px;
				color: #ffffff;
				border-bottom: 1px dashed #1d4495;
				@include flex-box(flex-start, center);
				&:hover{
					background-color: rgba(49, 88, 128, 0.4);
				}
                .selected{
                    background-color: rgba(49, 88, 128, 0.4);
                }
				.list_item {
					min-height: 70px;
					text-align: center;
					@include flex-box(center, center);
					&:nth-child(1) {
                        width: 292px;
						margin-right: 4px;
					}
					&:nth-child(2) {
						width: 96px;
					    margin-right: 4px;
					}
					&:nth-child(3) {
						width: 255px;
						margin-right: 4px;
					}
					&:nth-child(4) {
						width: 116px;
						margin-right: 4px;
					}
					&:nth-child(5) {
						width: 116px;
						margin-right: 4px;
					}
					&:nth-child(6) {
						width: 116px;
					    margin-right: 4px;
					}
					&:nth-child(7) {
						width: 190px;
						margin-right: 4px;
						cursor: pointer;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					&:nth-child(8) {
						width: 242px;
					}
					img {
						width: 40px;
						height: 40px;
						border-radius: 50%;
					}
					div {
						@include flex-box(center, center);
					}

                    .select {
                      width: 20px;
                      height: 20px;
                      border: 1px solid #65a6dd;
                      border-radius: 2px;
                      cursor: pointer;
                      @include prefixCss3(transition, border-color 0.2s);
                      &:hover {
                        border-color: #409eff;
                      }
                      &.active {
                        background-color: #409eff;
                        border-color: #409eff;
                        &::after {
                          content: '';
                          display: block;
                          width: 100%;
                          height: 100%;
                          @include set-bg-img('../../../assets/images/icon-yes.png');
                        }
                      }
                    }
				}
			}
		}
	}
}
.box_line {
	>>> .el-input__inner {
		width: 211px;
		height: 30px;
		border-radius: 2px;
		border: none;
		color: rgba(77, 180, 244, 0.7);
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>>.el-select__caret {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown {
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(77, 180, 244, 1);
	}
	>>> .popper__arrow {
		border-bottom-color: rgba(77, 180, 244, 1) !important;
	}
	>>> .el-select-dropdown__item {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown__item:hover {
		color: #409eff;
	}
	>>> .el-select-dropdown__item.hover {
		color: #409eff;
	}
	>>> .el-input__icon {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-range-input {
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>> .el-range-separator {
		color: rgba(77, 180, 244, 0.7);
	}
}

.dialog_editfile {
	.btn_line {
		@include flex-box(center, center);
	}
	>>> .el-dialog {
		width: 660px;
		// height: 500px;
		margin-top: 25vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58, 116, 221, 1);
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	>>> .el-dialog__close {
		color: #4db4f4;
	}
}

.dialog_editdevice {
	.btn_line {
		@include flex-box(center, center);
	}
	>>> .el-dialog {
		width: 660px;
		// height: 600px;
		margin-top: 20vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58, 116, 221, 1);
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	>>> .el-dialog__close {
		color: #4db4f4;
	}
}

.dialog_library {
	.btn_line {
		@include flex-box(center, center);
	}
	>>> .el-dialog {
		width: 830px;
		height: 600px;
		margin-top: 20vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58, 116, 221, 1);
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	>>> .el-dialog__close {
		color: #4db4f4;
	}
}

>>>.el-input-number{
    height: 31px;
    width: 120px;
    .el-input-number__decrease{
        width: 30px;
        height: 30px;
        background-color: rgba(255,255,255,.3);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        border: 0;
    }
    .el-input-number__increase{
        width: 30px;
        height: 30px;
        background-color: rgba(255,255,255,.3);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        border: 0;
    }
    .el-input{
        height: 30px;
          display: flex;
        .el-input__inner{
            width: 120px;
            color: rgba(77,180,244,.7) !important;
            font-size: 12px;
            height: 34px;
        }
    }
}

.btn_green {
    background: url(../../../assets/img/per_bg_g.png) no-repeat;
    background-size: 100% 100%;
}

.btn_red {
    background: url(../../../assets/img/btn_bg_rsm.png) no-repeat;
    background-size: 100% 100%;
}

.btn_orange {
    background: url(../../../assets/img/btn_bg_osm.png) no-repeat;
    background-size: 100% 100%;
}

>>>.el-icon-video-play{
    background: url(../../../assets/img/play.png) no-repeat;
  font-size: 12px;
  background-size: cover;
}
>>>.el-icon-video-play:before{
    content: "替";
    font-size: 12px;
    visibility: hidden;
}

>>>.el-icon-video-pause{
    background: url(../../../assets/img/pause.png) no-repeat;
     font-size: 12px;
     background-size: cover;
   }
>>>.el-icon-video-pause:before{
    content: "替";
    font-size: 12px;
    visibility: hidden;
}

.el-range-editor-my{
    width:392px !important;
    border-bottom-left-radius: 0 !important;
    border-top-left-radius: 0 !important;
    >>> input{
        color: rgba(77,180,244,.7);
    }
}


</style>


// WEBPACK FOOTER //
// src/views/Broadcast/broadcastDefault/indexV2.vue